import { render, staticRenderFns } from "./CDialogProvider.vue?vue&type=template&id=d22b4936"
import script from "./CDialogProvider.vue?vue&type=script&lang=js"
export * from "./CDialogProvider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports